(function () {
  if (window.wtHomepageController) {
    window.wtHomepageController.initAll();
    return;
  }

  var controllers = new WeakMap();

  function showReveals(root) {
    var items = root.querySelectorAll('[data-wt-reveal]');
    for (var index = 0; index < items.length; index++) {
      items[index].classList.add('is-visible');
    }
  }

  function createMotion(root, pointerMotion, introduceHero) {
    var cleanups = [];
    var reveals = root.querySelectorAll('[data-wt-reveal]');
    var stages = root.querySelectorAll('[data-wt-hero-stage]');
    var hero = root.querySelector('.wt-home__hero');
    var media = root.querySelector('[data-wt-hero-media]');
    var heroCopy = root.querySelector('.wt-home__hero-content');
    var cards = [];
    var frame = 0;
    var previousTime = 0;
    var destroyed = false;
    var heroVisible = Boolean(hero);
    var heroTop = 0;
    var heroHeight = 1;
    var pointerX = 0;
    var pointerY = 0;
    var heroX = 0;
    var heroY = 0;
    var copyX = 0;
    var copyY = 0;
    var targetHeroX = 0;
    var targetHeroY = 0;
    var targetCopyX = 0;
    var targetCopyY = 0;
    var introTimer;
    var revealObserver;
    var heroObserver;

    function listen(target, type, handler, options) {
      target.addEventListener(type, handler, options);
      cleanups.push(function () { target.removeEventListener(type, handler, options); });
    }

    function schedule() {
      if (!frame && !destroyed && !document.hidden) frame = requestAnimationFrame(render);
    }

    function render(time) {
      frame = 0;
      if (destroyed || document.hidden) return;
      var delta = previousTime ? Math.min((time - previousTime) / 1000, .032) : 1 / 60;
      previousTime = time;
      var running = false;

      for (var index = 0; index < cards.length; index++) {
        var card = cards[index];
        if (!card.running) continue;
        // A damped spring carries the card's velocity through interrupted pointer movement.
        card.velocityX += ((card.targetX - card.x) * 190 - card.velocityX * 24) * delta;
        card.velocityY += ((card.targetY - card.y) * 190 - card.velocityY * 24) * delta;
        card.velocityLift += ((card.targetLift - card.lift) * 190 - card.velocityLift * 24) * delta;
        card.x += card.velocityX * delta;
        card.y += card.velocityY * delta;
        card.lift += card.velocityLift * delta;
        card.running = Math.abs(card.targetX - card.x) + Math.abs(card.targetY - card.y) + Math.abs(card.targetLift - card.lift) > .025 || Math.abs(card.velocityX) + Math.abs(card.velocityY) + Math.abs(card.velocityLift) > .05;
        if (!card.running) {
          card.x = card.targetX;
          card.y = card.targetY;
          card.lift = card.targetLift;
          card.velocityX = card.velocityY = card.velocityLift = 0;
          card.element.classList.remove('is-depth-moving');
          card.element.style.removeProperty('will-change');
        }
        card.element.style.setProperty('--wt-tilt-x', card.x.toFixed(3) + 'deg');
        card.element.style.setProperty('--wt-tilt-y', card.y.toFixed(3) + 'deg');
        card.element.style.setProperty('--wt-lift', card.lift.toFixed(3) + 'px');
        if (!card.running && !card.engaged) {
          card.element.style.removeProperty('--wt-tilt-x');
          card.element.style.removeProperty('--wt-tilt-y');
          card.element.style.removeProperty('--wt-lift');
        }
        running = running || card.running;
      }

      if (pointerMotion && heroVisible && media && heroCopy) {
        var blend = 1 - Math.exp(-10 * delta);
        heroX += (targetHeroX - heroX) * blend;
        heroY += (targetHeroY - heroY) * blend;
        copyX += (targetCopyX - copyX) * blend;
        copyY += (targetCopyY - copyY) * blend;
        var heroMoving = Math.abs(targetHeroX - heroX) + Math.abs(targetHeroY - heroY) + Math.abs(targetCopyX - copyX) + Math.abs(targetCopyY - copyY) > .025;
        if (!heroMoving) {
          heroX = targetHeroX;
          heroY = targetHeroY;
          copyX = targetCopyX;
          copyY = targetCopyY;
        }
        media.style.setProperty('--wt-hero-x', heroX.toFixed(3) + 'px');
        media.style.setProperty('--wt-hero-y', heroY.toFixed(3) + 'px');
        heroCopy.style.setProperty('--wt-hero-copy-x', copyX.toFixed(3) + 'px');
        heroCopy.style.setProperty('--wt-hero-copy-y', copyY.toFixed(3) + 'px');
        if (heroMoving) {
          media.style.willChange = 'transform';
          heroCopy.style.willChange = 'transform';
        } else {
          media.style.removeProperty('will-change');
          heroCopy.style.removeProperty('will-change');
        }
        running = running || heroMoving;
      }

      if (running) schedule();
      else previousTime = 0;
    }

    function updateHeroTargets() {
      if (!heroVisible) return;
      var progress = Math.max(0, Math.min(1, (window.scrollY - heroTop) / heroHeight));
      targetHeroX = pointerX * 12;
      targetHeroY = progress * 46 + pointerY * 8;
      targetCopyX = pointerX * -4;
      targetCopyY = progress * 16 + pointerY * -3;
      schedule();
    }

    function measureHero() {
      if (!hero) return;
      var bounds = hero.getBoundingClientRect();
      heroTop = bounds.top + window.scrollY;
      heroHeight = bounds.height || 1;
      if (!heroObserver) heroVisible = bounds.bottom > 0 && bounds.top < window.innerHeight;
      updateHeroTargets();
    }

    function measureCard(card) {
      var bounds = card.element.getBoundingClientRect();
      card.left = bounds.left + window.scrollX;
      card.top = bounds.top + window.scrollY;
      card.width = bounds.width || 1;
      card.height = bounds.height || 1;
    }

    function startCard(card) {
      card.running = true;
      card.element.classList.add('is-depth-moving');
      card.element.style.willChange = 'transform';
      schedule();
    }

    function moveCard(card, event) {
      if (!card.engaged || event.pointerType === 'touch') return;
      var x = Math.max(-1, Math.min(1, (event.pageX - card.left) / card.width * 2 - 1));
      var y = Math.max(-1, Math.min(1, (event.pageY - card.top) / card.height * 2 - 1));
      card.targetX = y * -3;
      card.targetY = x * 4;
      card.targetLift = -5;
      startCard(card);
    }

    function bindCard(element) {
      var card = { element: element, x: 0, y: 0, lift: 0, velocityX: 0, velocityY: 0, velocityLift: 0, targetX: 0, targetY: 0, targetLift: 0, engaged: false, running: false, left: 0, top: 0, width: 1, height: 1 };
      cards.push(card);
      listen(element, 'pointerenter', function (event) {
        if (event.pointerType === 'touch') return;
        card.engaged = true;
        measureCard(card);
        moveCard(card, event);
      });
      listen(element, 'pointermove', function (event) { moveCard(card, event); });
      listen(element, 'pointerleave', function () {
        if (!card.engaged) return;
        card.engaged = false;
        card.targetX = card.targetY = card.targetLift = 0;
        startCard(card);
      });
    }

    root.classList.add('is-motion-ready');
    root.classList.toggle('is-pointer-motion', pointerMotion);
    for (var index = 0; index < reveals.length; index++) {
      var item = reveals[index];
      var sibling = item.previousElementSibling;
      var order = 0;
      while (sibling) {
        if (sibling.hasAttribute('data-wt-reveal')) order++;
        sibling = sibling.previousElementSibling;
      }
      item.style.setProperty('--wt-reveal-delay', Math.min(order, 3) * 75 + 'ms');
    }

    if ('IntersectionObserver' in window) {
      revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          if (!entry.target.classList.contains('is-visible')) entry.target.style.willChange = 'opacity, transform';
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        });
      }, { threshold: .08, rootMargin: '0px 0px -24px 0px' });
      for (var revealIndex = 0; revealIndex < reveals.length; revealIndex++) revealObserver.observe(reveals[revealIndex]);
    } else {
      showReveals(root);
    }

    listen(root, 'focusin', function (event) {
      var item = event.target.closest('[data-wt-reveal]');
      if (item) {
        if (!item.classList.contains('is-visible')) item.style.willChange = 'opacity, transform';
        item.classList.add('is-visible');
      }
    });

    listen(root, 'transitionend', function (event) {
      if (event.propertyName === 'transform' && event.target.hasAttribute('data-wt-reveal') && !event.target.classList.contains('is-depth-moving')) {
        event.target.style.removeProperty('will-change');
      }
    });

    if (introduceHero) {
      for (var stageIndex = 0; stageIndex < stages.length; stageIndex++) stages[stageIndex].style.setProperty('--wt-stage-delay', stageIndex * 90 + 'ms');
      root.classList.add('is-hero-entering');
      introTimer = setTimeout(function () { root.classList.remove('is-hero-entering'); }, 1250);
    }

    if (pointerMotion) {
      var depthItems = root.querySelectorAll('[data-wt-depth]');
      for (var depthIndex = 0; depthIndex < depthItems.length; depthIndex++) bindCard(depthItems[depthIndex]);
      if (hero && media && heroCopy) {
        if ('IntersectionObserver' in window) {
          heroObserver = new IntersectionObserver(function (entries) {
            heroVisible = entries[0].isIntersecting;
            if (heroVisible) updateHeroTargets();
            else {
              media.style.removeProperty('will-change');
              heroCopy.style.removeProperty('will-change');
            }
          });
          heroObserver.observe(hero);
        }
        measureHero();
        listen(hero, 'pointermove', function (event) {
          if (event.pointerType === 'touch') return;
          pointerX = Math.max(-1, Math.min(1, event.clientX / window.innerWidth * 2 - 1));
          pointerY = Math.max(-1, Math.min(1, (event.pageY - heroTop) / heroHeight * 2 - 1));
          updateHeroTargets();
        });
        listen(hero, 'pointerleave', function () { pointerX = pointerY = 0; updateHeroTargets(); });
        listen(window, 'scroll', function () {
          if (!heroObserver) heroVisible = window.scrollY + window.innerHeight > heroTop && window.scrollY < heroTop + heroHeight;
          updateHeroTargets();
        }, { passive: true });
      }
      listen(window, 'resize', function () {
        measureHero();
        for (var cardIndex = 0; cardIndex < cards.length; cardIndex++) {
          if (cards[cardIndex].engaged) measureCard(cards[cardIndex]);
        }
      }, { passive: true });
      listen(document, 'visibilitychange', function () {
        if (document.hidden) {
          cancelAnimationFrame(frame);
          frame = previousTime = 0;
        } else schedule();
      });
    }

    return function () {
      destroyed = true;
      cancelAnimationFrame(frame);
      clearTimeout(introTimer);
      if (revealObserver) revealObserver.disconnect();
      if (heroObserver) heroObserver.disconnect();
      for (var cleanupIndex = 0; cleanupIndex < cleanups.length; cleanupIndex++) cleanups[cleanupIndex]();
      root.classList.remove('is-motion-ready', 'is-pointer-motion', 'is-hero-entering');
      for (var cardIndex = 0; cardIndex < cards.length; cardIndex++) {
        cards[cardIndex].element.classList.remove('is-depth-moving');
        cards[cardIndex].element.style.removeProperty('--wt-tilt-x');
        cards[cardIndex].element.style.removeProperty('--wt-tilt-y');
        cards[cardIndex].element.style.removeProperty('--wt-lift');
        cards[cardIndex].element.style.removeProperty('will-change');
      }
      for (var revealIndex = 0; revealIndex < reveals.length; revealIndex++) {
        reveals[revealIndex].style.removeProperty('--wt-reveal-delay');
        reveals[revealIndex].style.removeProperty('will-change');
      }
      for (var stageIndex = 0; stageIndex < stages.length; stageIndex++) stages[stageIndex].style.removeProperty('--wt-stage-delay');
      if (media) {
        media.style.removeProperty('--wt-hero-x');
        media.style.removeProperty('--wt-hero-y');
        media.style.removeProperty('will-change');
      }
      if (heroCopy) {
        heroCopy.style.removeProperty('--wt-hero-copy-x');
        heroCopy.style.removeProperty('--wt-hero-copy-y');
        heroCopy.style.removeProperty('will-change');
      }
    };
  }

  function initHomepage(root) {
    if (!root || controllers.has(root)) return;
    root.dataset.wtReady = 'true';

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
    var motionCleanup = function () {};
    var motionInitialized = false;

    function updateMotionPreference() {
      motionCleanup();
      motionCleanup = function () {};
      if (reducedMotion.matches) showReveals(root);
      else motionCleanup = createMotion(root, finePointer.matches, !motionInitialized);
      motionInitialized = true;
    }

    reducedMotion.addEventListener('change', updateMotionPreference);
    finePointer.addEventListener('change', updateMotionPreference);
    updateMotionPreference();
    controllers.set(root, function () {
      motionCleanup();
      reducedMotion.removeEventListener('change', updateMotionPreference);
      finePointer.removeEventListener('change', updateMotionPreference);
      delete root.dataset.wtReady;
      controllers.delete(root);
    });
  }

  function eachRoot(container, callback) {
    if (container.matches && container.matches('[data-wt-home]')) callback(container);
    Array.prototype.forEach.call(container.querySelectorAll('[data-wt-home]'), callback);
  }

  function initAll() {
    eachRoot(document, initHomepage);
  }

  window.wtHomepageController = { initAll: initAll };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    eachRoot(event.target, initHomepage);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    eachRoot(event.target, function (root) {
      var cleanup = controllers.get(root);
      if (cleanup) cleanup();
    });
  });
}());
